export class QuestionModel {
    id: number | undefined
    formulario_id:  number | undefined
    sort:  number | undefined
    category: String | undefined
    question: String | undefined
    type: String | undefined
    extras: any | undefined
    created_at: String | undefined
    updated_at: String | undefined
    nextQuestion: QuestionModel
    answer: any
}